import {Formik} from 'formik'
import React, {useEffect, useState} from 'react'
import {SelectInput} from '../../../widgets/components/Input/SelectInput'
import SelectSearchInput from '../../../widgets/components/Input/SelectSearchInput'
import TextInput from '../../../widgets/components/Input/TextInput'
import {BasicButton} from '../../../widgets/components/UI/BasicButton'
import {useIntl} from 'react-intl'
import * as Yup from 'yup'
import crossIcon from '../../../../../_metronic/assets/images/svg/data-room/cross-black-icon.svg'
import {useThemeMode} from '../../../../../_metronic/partials'
import {convertToBytes} from '../../../../core/_util'
import {getAllSourcesList, getRecordKeeperUserListApi} from '../../core/_requests'
import {useAuth} from '../../../auth'
import Skeleton from 'react-loading-skeleton'
import {useInvestorDatabase} from '../../../investor-database/core/InvestorContext'

export const SyncedFileFilter = ({
  filter,
  setFilter,
  setClear,
  setFileNameSearch,
  setSourceNameSearch,
  setSyncedStatusSearch,
  setMaxSize,
  setMinSize,
  setUploadedAfter,
  setUploadedBefore,
  setUploadedBy,
  setIsFilterApplied,
}: any) => {
  const {formatMessage} = useIntl()
  const {mode} = useThemeMode()
  const [filterLoading, setFilterLoading] = useState(false) //eslint-disable-line
  const {companyId} = useAuth()
  const [sources, setSources] = useState<any[]>([])
  const [userList, setUserList] = useState<any[]>([])
  const [isSourceLoading, setIsSourceLoading] = useState(false)
  const [isUserListLoading, setIsUserListLoading] = useState(false)
  const {setBlockOutsideClick} = useInvestorDatabase()

  useEffect(() => {
    fetchSources()
    fetchUserList()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  async function fetchSources() {
    if (!companyId) return
    setIsSourceLoading(true)
    try {
      const {
        data: {success, data, errors},
      } = await getAllSourcesList(companyId!, true)
      if (success) {
        setSources(data.sources)
      } else {
        console.error(errors)
      }
    } catch (error) {
      console.error(error)
    } finally {
      setIsSourceLoading(false)
    }
  }

  async function fetchUserList() {
    if (!companyId) return
    setIsUserListLoading(true)
    try {
      const {
        data: {success, data, errors},
      } = await getRecordKeeperUserListApi(companyId!, true)
      if (success) {
        setUserList(data)
      } else {
        console.error(errors)
      }
    } catch (error) {
      console.error(error)
    } finally {
      setIsUserListLoading(false)
    }
  }

  const initialValues = {
    fileNameSearch: '',
    sourceName: [],
    syncedStatus: '',
    maxSize: null,
    minSize: null,
    syncedAfter: '',
    syncedBefore: '',
    uploadedBy: [],
    maxSizeType: '',
    minSizeType: '',
  }

  const searchSchema = Yup.object().shape({
    maxSize: Yup.number().nullable().min(1, "Maximum file size cann't be negative or 0"),
    minSize: Yup.number().nullable().min(1, "Minimum file size cann't be negative or 0"),
  })
  const closeFilter = () => {
    setBlockOutsideClick(false)
    setFilter(false)
  }

  const clearFilters = (formik: any) => {
    setBlockOutsideClick(false)
    setIsFilterApplied(false)
    formik.resetForm({values: formik.initialValues})
    setClear(true)
    setFilter(false)
    setFileNameSearch('')
    setSourceNameSearch([])
    setSyncedStatusSearch('')
    setMaxSize('')
    setMinSize('')
    setUploadedAfter('')
    setUploadedBefore('')
    setUploadedBy([])
  }

  const onApplyFilter = async (values: any) => {
    setIsFilterApplied(true)
    setBlockOutsideClick(false)
    setFileNameSearch(values.fileNameSearch)
    if (values.sourceName.length > 0) {
      setSourceNameSearch(values.sourceName.map((source: any) => source.id))
    }

    if (values.uploadedBy.length > 0) {
      setUploadedBy(values.uploadedBy.map((user: any) => user.id))
    }

    setSyncedStatusSearch(values.syncedStatus.value)
    if (values.maxSize && values.maxSizeType) {
      setMaxSize(convertToBytes(values.maxSize, values.maxSizeType))
    }

    if (values.minSize && values.minSizeType) {
      setMinSize(convertToBytes(values.minSize, values.minSizeType))
    }
    setUploadedAfter(values.syncedAfter)
    setUploadedBefore(values.syncedBefore)
    setFilterLoading(true)
    setFilterLoading(false)
    setFilter(false)
    setClear(false)
  }

  return (
    <div
      className={filter ? 'bg-body drawer drawer-end drawer-on' : 'bg-body drawer drawer-end'}
      id='fc-filter'
      data-kt-drawer='true'
      data-kt-drawer-name='filter'
      data-kt-drawer-overlay='true'
      data-kt-drawer-activate='true'
      data-kt-drawer-width="{default:'300px', 'md': '400px'}"
      data-kt-drawer-direction='end'
    >
      {/* Card */}
      <div className='card shadow-none rounded-0 w-100'>
        {/* Header */}
        <div className='card-header' id='fc_header'>
          <div className='card-toolbar gap-6'>
            <button
              type='button'
              className='btn btn-sm btn-icon explore-btn-dismiss me-n5'
              onClick={closeFilter}
            >
              <img src={crossIcon} alt='Close' />
            </button>
            <h5 className='card-title fw-bold'>{formatMessage({id: 'Sort or Filter'})}</h5>
          </div>
        </div>
        {/* Body */}
        <Formik
          initialValues={initialValues}
          validationSchema={searchSchema}
          onSubmit={onApplyFilter}
          validateOnMount
          enableReinitialize
        >
          {(formik: any) => {
            console.log(formik.values, '  formik')
            return (
              <>
                <div className='card-body'>
                  {/* Clear All Filters */}
                  <div className='mb-5'>
                    <BasicButton
                      id='fc-clear'
                      height='36px'
                      border='none'
                      color={mode === 'dark' ? '#323248' : '#F5F8FA'}
                      textColor={mode === 'dark' ? '#FFFFFF' : '#585960'}
                      padding='8px 16px'
                      buttonText={formatMessage({id: 'Clear All filters'})}
                      minWidth={125}
                      onClick={() => clearFilters(formik)}
                    />
                  </div>
                  <TextInput
                    fieldType='text'
                    fieldName='fileNameSearch'
                    formik={formik}
                    label={formatMessage({id: 'File Name'})}
                    placeholder={formatMessage({id: 'Search Files Name'})}
                    isWidthNotRequired={true}
                    isTooltipNotRequired={true}
                  />
                  {isSourceLoading ? (
                    <div className='mb-4'>
                      <label htmlFor=''>Storage Name(s)</label>
                      <Skeleton
                        width={'100%'}
                        height={35}
                        baseColor='var(--kt-skeleton-bg-color)'
                        highlightColor='var(--kt-skeleton-highlight-bg-color)'
                      />
                    </div>
                  ) : (
                    <SelectSearchInput
                      label={formatMessage({id: 'Storage Name(s)'})}
                      fieldName='sourceName'
                      placeholder={formatMessage({
                        id: 'Please Select the storage names',
                      })}
                      formik={formik}
                      options={sources.map((source) => ({
                        id: source.sourceId,
                        label: source.storageName,
                        value: source.sourceId,
                      }))}
                      isStarRequired={false}
                      isTooltipNotRequired={true}
                      isMulti
                    />
                  )}

                  <SelectSearchInput
                    label={formatMessage({id: 'Synced Status'})}
                    fieldName='syncedStatus'
                    placeholder={formatMessage({
                      id: 'Please Select the statuses',
                    })}
                    formik={formik}
                    options={[
                      {id: 'synced', label: 'Synced', value: 'synced'},
                      {id: 'failed', label: 'Failed', value: 'failed'},
                      {id: 'processed', label: 'Processed', value: 'processed'},
                      {id: 'classified', label: 'Classified', value: 'classified'},
                      {id: 'embedded', label: 'Embedded', value: 'embedded'},
                    ]}
                    isStarRequired={false}
                    isTooltipNotRequired={true}
                    isMulti={false}
                  />
                  <TextInput
                    fieldType='date'
                    fieldName='syncedAfter'
                    formik={formik}
                    label={formatMessage({id: 'Synced After'})}
                    placeholder={formatMessage({id: 'Please Select the timestamp'})}
                    isWidthNotRequired={true}
                    isTooltipNotRequired={true}
                  />
                  <TextInput
                    fieldType='date'
                    fieldName='syncedBefore'
                    formik={formik}
                    label={formatMessage({id: 'Synced Before'})}
                    placeholder={formatMessage({id: 'Please Select the timestamp'})}
                    isWidthNotRequired={true}
                    isTooltipNotRequired={true}
                  />
                  <div>
                    <label>{formatMessage({id: 'File Size Bigger Than'})}</label>
                    <div className='d-flex align-items-start'>
                      <div className='col-md-8 col-8 pe-2 '>
                        <TextInput
                          fieldType='number'
                          fieldName='minSize'
                          onFocus={formik.handleFocus}
                          onBlur={formik.handleBlur}
                          formik={formik}
                          placeholder={'Enter Size'}
                          isTooltipNotRequired
                        />
                      </div>

                      <div className='col-md-4 col-4 mb-1 mt-2'>
                        <SelectInput
                          fieldName='minSizeType'
                          placeholder='Select'
                          formik={formik}
                          options={['KB', 'MB', 'GB']}
                          isTooltipNotRequired
                        />
                      </div>
                    </div>
                  </div>
                  <div>
                    <label>{formatMessage({id: 'File Size Smaller Than'})}</label>
                    <div className='d-flex align-items-start'>
                      <div className='col-md-8 col-8 pe-2'>
                        <TextInput
                          fieldType='number'
                          fieldName='maxSize'
                          onFocus={formik.handleFocus}
                          onBlur={formik.handleBlur}
                          formik={formik}
                          placeholder={'Enter Size'}
                          isTooltipNotRequired
                        />
                      </div>

                      <div className='col-md-4 col-4 mt-2'>
                        <SelectInput
                          fieldName='maxSizeType'
                          placeholder='Select'
                          formik={formik}
                          options={['KB', 'MB', 'GB']}
                          isTooltipNotRequired
                        />
                      </div>
                    </div>
                  </div>
                  {isUserListLoading ? (
                    <div className='mb-4'>
                      <label htmlFor=''>Uploaded By</label>
                      <Skeleton
                        width={'100%'}
                        height={35}
                        baseColor='var(--kt-skeleton-bg-color)'
                        highlightColor='var(--kt-skeleton-highlight-bg-color)'
                      />
                    </div>
                  ) : (
                    <div className='mb-8'>
                      <SelectSearchInput
                        label={formatMessage({id: 'Uploaded By'})}
                        fieldName='uploadedBy'
                        placeholder={formatMessage({
                          id: 'Please Select the User',
                        })}
                        formik={formik}
                        options={userList}
                        isStarRequired={false}
                        isTooltipNotRequired={true}
                        isMulti
                      />
                    </div>
                  )}
                </div>
                {/* Footer */}
                <div
                  className='d-flex justify-content-center m-md-5 m-0 w-100 w-md-auto px-4'
                  id='fc_footer'
                >
                  <BasicButton
                    id='fc-apply'
                    border='#4776E6'
                    color='#4776E6'
                    textColor='#FFFFFF'
                    // padding="16px 138px"
                    buttonText={formatMessage({id: 'Apply filters'})}
                    minWidth={352}
                    loading={filterLoading}
                    disabled={filterLoading || !formik.isValid || isSourceLoading}
                    onClick={() => onApplyFilter(formik.values)}
                    customClass='w-100 mb-4 custom-button-property'
                  />
                </div>
              </>
            )
          }}
        </Formik>
      </div>
    </div>
  )
}
